import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export const useDisableResellerLanguagePublication = () => {
  return useMutation<void, AxiosError<BaseError>, number>(
    async (publicationId: number) => {
      const { deleteResellerLanguagePublication } = DELETE_URL(
        String(publicationId)
      );
      await Axios.delete(deleteResellerLanguagePublication);
    }
  );
};
